var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Product",
    clipPath: "url(#clip0_8011_14434)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 5148,
    transform: "translate(-1037 -3339)",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 53047"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 53044",
    filter: "url(#filter0_bd_8011_14434)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -47.5,
    y: -47.7676,
    width: 744,
    height: 629,
    rx: 16,
    fill: "url(#paint0_linear_8011_14434)",
    fillOpacity: 0.15,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -47,
    y: -47.2676,
    width: 743,
    height: 628,
    rx: 15.5,
    stroke: "url(#paint1_linear_8011_14434)",
    strokeOpacity: 0.3,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    id: "diamond-01 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.50298 18.2324H43.5029M20.503 6.23242L16.503 18.2324L24.5029 41.2324L32.5029 18.2324L28.5029 6.23242M25.7321 40.7574L43.6493 19.2567C43.9531 18.8923 44.1049 18.7101 44.1629 18.5068C44.2141 18.3274 44.2141 18.1374 44.1629 17.9581C44.1049 17.7547 43.9531 17.5725 43.6493 17.2081L34.9827 6.80812C34.8063 6.5965 34.7183 6.4907 34.6101 6.41464C34.5143 6.34724 34.4075 6.29718 34.2945 6.26676C34.1667 6.23242 34.0291 6.23242 33.7535 6.23242H15.2524C14.9769 6.23242 14.8392 6.23242 14.7115 6.26676C14.5985 6.29718 14.4916 6.34724 14.3958 6.41464C14.2877 6.4907 14.1996 6.5965 14.0232 6.80812L5.35656 17.2081C5.0529 17.5725 4.90106 17.7547 4.84304 17.9581C4.7919 18.1374 4.7919 18.3274 4.84304 18.5067C4.90106 18.7101 5.0529 18.8923 5.35656 19.2567L23.2739 40.7574C23.6959 41.264 23.9069 41.5172 24.1597 41.6096C24.3813 41.6906 24.6245 41.6906 24.8463 41.6096C25.0989 41.5172 25.3101 41.264 25.7321 40.7574Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_8011_14434",
    x: -99.9562,
    y: -95.9416,
    width: 848.912,
    height: 733.912,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 13.3817
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8011_14434"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.28214
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.2281
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0283334 0 0 0 0 0.283333 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_8011_14434",
    result: "effect2_dropShadow_8011_14434"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8011_14434",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8011_14434",
    x1: -47.5,
    y1: -67.3626,
    x2: 386.164,
    y2: 1039.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8011_14434",
    x1: -73.8947,
    y1: -101.654,
    x2: 341.927,
    y2: 809.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8011_14434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 5148,
    fill: "white",
    transform: "translate(-1037 -3339)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.907a138e5aaf4dbc94ae0feab2454a91.svg";
export { ForwardRef as ReactComponent };